import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, isLoggingOut } = useAuth();
  // Latches after the first redirect for this component's whole mounted
  // lifetime — one redirect ever per mount, not one per logout.
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    // Skip while AuthContext's logout() is already handling the redirect —
    // it defers navigation so cross-origin fan-out iframes have time to load
    // and postMessage; firing here immediately would abort that fan-out.
    if (!loading && !isAuthenticated && !isLoggingOut && !hasRedirectedRef.current) {
      hasRedirectedRef.current = true;
      const platformUrl = process.env.REACT_APP_PLATFORM_URL;
      window.location.replace(platformUrl ? `${platformUrl}/login` : '/login');
    }
  }, [loading, isAuthenticated, isLoggingOut]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return null;

  return children;
}
